<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-7">
    <slot />
  </div>
</template>

<style scoped>

</style>
